import { isly } from "isly";
export var Numeric;
(function (Numeric) {
    var _a;
    _a = isly
        .number("range", 0, 9999)
        .restrict("integer")
        .rename("isoly.Date.Year.Numeric")
        .describe("Numeric year between 0 and 9999.")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function parse(value) {
        const result = Number.parseInt(value);
        return Numeric.is(result) ? result : undefined;
    }
    Numeric.parse = parse;
    function isLeapYear(year) {
        return !!year && year % 4 === 0 && (year % 100 != 0 || year % 400 == 0);
    }
    Numeric.isLeapYear = isLeapYear;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map